export const allowedParams = ['nosto', 'objectId', 'queryId', 'indexName'];
